import request from '@/utils/seftRequest';

export function updateAccount(params) {
  return request('/ding/acctService/accountServiceRequestBsnl', {
    method: 'POST',
    body: params,
  });
}

export function qryPaymentType(params) {
  return request('/ding/acctService/qryPaymentTypeBsnl', { params });
}

export function qryPaymentMethod(params) {
  return request('/ding/acctService/qryPaymentMethodBsnl', { params });
}

export function qryBankAcctType(params) {
  return request('/ding/acctService/qryBankAcctTypeBsnl', { params });
}

export function qryBankList(params) {
  return request('/ding/acctService/qryBankListBsnl', { params });
}

export function updateCust(params) {
  return request('/ding/custService/modCustomerBsnl', {
    method: 'POST',
    body: params,
  });
}

export function resetWscPwd(params) {
  return request('/ding/subsService/resetWscPwdBsnl', {
    method: 'POST',
    body: params,
  });
}

export function sendWscPwdResetOtp(params) {
  return request('/ding/subsService/sendWscPwdResetOtpBsnl', {
    method: 'POST',
    body: params,
  });
}


export function manageMandateInfo(params) {
  return request('/ding/acctService/manageMandateInfoBsnl', {
    method: 'POST',
    body: params,
  });
}

export function modCustAddressPOA(params) {
  return request('/ding/custService/modCustAddressPOA', {
    method: 'POST',
    body: params,
  });
}
